<section class="bg-primary-text bg-primary text-center">
    <main class="bg-primary-text__container mx-auto">
        <h2 class="bg-primary-text__title text-white fs-1 fw-bold m-0">{{bgPrimaryTitle}}</h2>
        <p  class="text-white fw-normal ">{{bgPrimaryText}}</p>
        <p  class="text-white fw-normal ">{{bgPrimaryTextSecond}}</p>
        <p  class="text-white fw-normal ">{{bgPrimaryTextThirst}}</p>

    </main>
</section>
